import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Pages
import HomePage from './pages/HomePage';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import AGB from './pages/AGB';
import TerminVerwaltung from './pages/TerminVerwaltung';
import TerminBestaetigung from './pages/TerminBestaetigung';
import TerminBuchen from './pages/TerminBuchen';
import RechnungsTool from './pages/RechnungsTool';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/agb" element={<AGB />} />
        <Route path="/terminverwaltung" element={<TerminVerwaltung />} />
        <Route path="/termin-bestaetigung" element={<TerminBestaetigung />} />
        <Route path="/termin-buchen" element={<TerminBuchen />} />
        <Route path="/rechnungstool" element={<RechnungsTool />} />
      </Routes>
    </Router>
  );
}

export default App;